export default __webpack_public_path__ + "static/media/albt.858c8978.svg";